<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import Progress from '@/model/dataLayer/api/MembershipSystem/Progress'

export default {
  name: 'ProgressPage',
  components: {
    IkDataTable
  },
  data () {
    return {
      showRevokeDialog: false,
      recordDetail: null,
      model: Progress
    }
  }
}
</script>

<template>
  <v-container>
    <ik-data-table
      ref="table"
      :model="model"
      :use-default-action="false"
      entity-name="奖励进度"
      icon="mdi-cash-usd"
    />
  </v-container>
</template>

<style scoped>

</style>
